import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import store from "@/store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/signin",
    name: "Signin",
    component: () =>
      import(/* webpackChunkName: "signin" */ "../views/Signin.vue")
  },
  {
    path: "/signup",
    name: "Signup",
    component: () =>
      import(/* webpackChunkName: "signup" */ "../views/Signup.vue")
  },
  {
    path: "/kingscup",
    name: "Kingscup",
    component: () =>
      import(/* webpackChunkName: "kingscup" */ "../views/Kingscup.vue")
  },
  {
    path: "/kingscup/:gameId",
    name: "KingscupGame",
    component: () =>
      import(/* webpackChunkName: "kingscupgame" */ "../views/KingscupGame.vue")
  },
  {
    path: "/*",
    name: "FourOFour",
    component: () => import(/* webpackChunkName: "404" */ "../views/404.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  let requiredSignins = ["Kingscup", "KingscupGame"];
  if (requiredSignins.includes(to.name) && store.state.user.token == "") {
    next({
      name: "Signin",
      query: {
        redirect: to.path
      }
    });
  } else {
    next();
  }
});

export default router;
